
export const numberFormatter = Intl.NumberFormat("de-CH",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

export const currencyFormatter = new Intl.NumberFormat("de-CH",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: "currency",
      currency: "CHF"
    });


export const millisToMinutesAndSeconds = (millis: number) =>  {
  const minutes = Math.floor(millis / 60000);
  const seconds = ((millis % 60000) / 1000).toFixed(3);
  return `${minutes}m ${seconds}s`;
}
